import { Component, OnInit, Input } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { COLOR } from 'src/app/services/static/color';
import {DrugsStatusChart} from '../../../model/model';

@Component({
    selector: 'app-drugs-status-chart',
    templateUrl: './drugs-status-chart.component.html',
    styleUrls: ['./drugs-status-chart.component.scss']
})
export class DrugsStatusChartComponent implements OnInit {

    @Input() data: DrugsStatusChart

    pieChartLabels: Label[] = [];
    pieChartData: number[] = [];

    pieChartType: ChartType = 'doughnut';
    pieChartLegend = true;

    pieChartOptions: ChartOptions = {
        responsive: true,
        legend: {
            position: 'right',
        },
        plugins: {
            datalabels: {
                formatter: (value, ctx) => {
                    const label = ctx.chart.data.labels[ctx.dataIndex];
                    return label;
                },
            },
        },
        title: {
            display: true,
            position: 'top',
            text: 'Drugs status'
        }
    };

    // pieChartPlugins = [pluginDataLabels];
    pieChartColors = [
        {
            backgroundColor: [
                COLOR.RED,
                COLOR.GREEN
            ],
        },
    ];


    constructor() { }

    ngOnInit() {
        const success: number = parseFloat(this.data.count)
        const error: number = parseFloat(this.data.total_drugs) - success

        this.pieChartLabels.push(...["Failed", "Success"])
        this.pieChartData.push(...[error, success])
    }

}
